// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1oNys","alertIcon":"ConfirmModal_alertIcon__1K0ti"};